import React, { Fragment, Component } from 'react';
import { Form, Checkbox } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import PropTypes from 'prop-types';
import _ from 'lodash';

import ReactTable from 'Common/ReactTableWrapper';
import { AssignEntitiesEnum, SiteEnum } from 'Common/FieldEnum';
import { YesNoDialog } from 'Components';
import {
  ReactTableWrapperColumnProperties,
  UNSAVED_MESSAGE,
} from 'Common/Constants';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';
import EditableLabel from 'Components/editableLabel/EditableLabel';
import {
  ASSIGN_ENTITIES_FORM_NAME,
  ASSIGN_ENTITIES_STORAGE_LOCATION_FORM_NAME,
} from 'Common/FormEnum';

import {
  getItemsBySiteId,
  getAllSites,
  getUsersBySiteId,
  clearItemGridFilter,
} from '../../../state/assignEntities/actions';
import {
  getCheckedData,
  checkVisibilityForSiteUser,
  getCheckedRefData,
  getFilteredIds,
  getCheckedGridData,
  GridResetInitialValueEnum,
  GridNames,
  getComponentOnSelection,
  ComponentMapping,
} from '../../../helper/assignEntities';
import * as Selectors from '../../../state/assignEntities/selectors';

class SiteGrid extends Component {
  static propTypes = {
    dataSource: PropTypes.array.isRequired,
    resetGridPage: PropTypes.object.isRequired,
    allSitesData: PropTypes.array.isRequired,
    allItemsData: PropTypes.array.isRequired,
    sitesByItemId: PropTypes.array.isRequired,
    usersBySiteId: PropTypes.array.isRequired,
    siteGridInfo: PropTypes.array,
    onResetPageOnDataChange: PropTypes.func,
    setIsReadOnlyState: PropTypes.func,
    setSiteGridInstance: PropTypes.func,
    onFilteredChange: PropTypes.func,
    getItemsBySiteId: PropTypes.func.isRequired,
    getAllSites: PropTypes.func.isRequired,
    getUsersBySiteId: PropTypes.func.isRequired,
    clearItemGridFilter: PropTypes.func.isRequired,
    onLeftGridFilteredChange: PropTypes.func,
    leftSideGridReactTableRef: PropTypes.object,
    rightSideGridReactTableRef: PropTypes.object,
    isReadOnly: PropTypes.bool,
    direction: PropTypes.bool,
    loadingAllSites: PropTypes.bool.isRequired,
    isLeftSideSiteGrid: PropTypes.bool,
    isRightSideItemGrid: PropTypes.bool,
    isLeftMultipleSelect: PropTypes.bool,
    isStorageLocationPage: PropTypes.bool,
    isLeftSideItemGrid: PropTypes.bool,
    isRightSideSiteGrid: PropTypes.bool,
    isRightGridFiltered: PropTypes.bool,
    isLeftGridFiltered: PropTypes.bool,
    loadingStorageLocationById: PropTypes.bool,
    sortOptionsValue: PropTypes.string.isRequired,
    dropDownValue: PropTypes.string,
  };

  static defaultProps = {
    direction: true,
    isReadOnly: true,
    isLeftSideSiteGrid: false,
    isRightSideItemGrid: false,
    isLeftMultipleSelect: false,
    isStorageLocationPage: false,
    isLeftSideItemGrid: false,
    isRightSideSiteGrid: false,
    isRightGridFiltered: false,
    isLeftGridFiltered: false,
    leftSideGridReactTableRef: null,
    rightSideGridReactTableRef: null,
    onLeftGridFilteredChange: () => {},
    onFilteredChange: () => {},
    setSiteGridInstance: () => {},
    onResetPageOnDataChange: () => {},
    setIsReadOnlyState: () => {},
    siteGridInfo: [],
    loadingStorageLocationById: false,
    dropDownValue: AssignEntitiesEnum.Site,
  };

  state = {
    selected: 0,
    SiteId: null,
    showUnsavedModal: false,
    rowInfo: null,
    columns: [
      {
        Header: () => {
          const {
            input: { value },
            dataSource,
            isStorageLocationPage,
            isLeftSideUserGrid,
            rightSideGridReactTableRef,
            siteGridInfo,
            leftSideGridReactTableRef,
          } = this.props;
          let check = false;
          if (
            value &&
            value.length &&
            dataSource.length > 0 &&
            (isStorageLocationPage || isLeftSideUserGrid)
          ) {
            if (
              (isLeftSideUserGrid &&
                rightSideGridReactTableRef &&
                rightSideGridReactTableRef.current) ||
              (isStorageLocationPage &&
                leftSideGridReactTableRef &&
                leftSideGridReactTableRef.current)
            ) {
              const sortedData = isLeftSideUserGrid
                ? rightSideGridReactTableRef.current.getResolvedState()
                    .sortedData
                : leftSideGridReactTableRef.current.getResolvedState()
                    .sortedData;
              check =
                sortedData.length > 0 &&
                sortedData.length ===
                  getCheckedGridData(sortedData, siteGridInfo, SiteEnum.Id)
                    .length;
            } else {
              check = dataSource.length === value.length;
            }
          } else if (
            rightSideGridReactTableRef &&
            rightSideGridReactTableRef.current
          ) {
            const sortedData = rightSideGridReactTableRef.current.getResolvedState()
              .sortedData;
            const checkedData = getCheckedData(
              getCheckedRefData(sortedData, SiteEnum.CheckBox),
              SiteEnum.CheckBox
            );
            check =
              sortedData.length > 0 && sortedData.length === checkedData.length;
          }
          return (
            <Checkbox
              style={{
                marginTop: 14,
              }}
              checked={check}
              onClick={(e, data) => {
                isStorageLocationPage || isLeftSideUserGrid
                  ? this.handleHeaderLevelCheckBoxWithStorageLocation(
                      data.checked
                    )
                  : this.handleHeaderLevelCheckbox(data.checked);
              }}
            />
          );
        },
        Cell: rowInfo => {
          const {
            input: { value },
            isStorageLocationPage,
            isLeftSideUserGrid,
          } = this.props;
          return (
            <div style={{ textAlign: 'center' }}>
              <Checkbox
                checked={
                  value && (isStorageLocationPage || isLeftSideUserGrid)
                    ? value.indexOf(rowInfo.original[SiteEnum.Id]) !== -1
                    : Boolean(rowInfo.original.CheckBox)
                }
                onClick={(e, data) => {
                  isStorageLocationPage || isLeftSideUserGrid
                    ? this.handleChangeCheckboxWithStorageLocation(
                        rowInfo.original,
                        data.checked
                      )
                    : this.handleChangeCheckbox(rowInfo.original, data.checked);
                }}
              />
            </div>
          );
        },
        sortable: false,
        filterable: false,
        maxWidth: 58,
        show:
          this.props.isStorageLocationPage || this.props.isRightSideSiteGrid,
        visibility:
          this.props.isStorageLocationPage || this.props.isRightSideSiteGrid,
        accessor: SiteEnum.CheckBox,
      },
      {
        Header: () => {
          return (
            <span>
              Site
              <br />
              Id
            </span>
          );
        },
        visibilityName: 'Id',
        accessor: SiteEnum.Id,
        ...ReactTableWrapperColumnProperties,
      },
      {
        Header: () => {
          return (
            <span>
              Site
              <br />
              Description
            </span>
          );
        },
        visibilityName: 'Site Description',
        accessor: SiteEnum.Description,
        ...ReactTableWrapperColumnProperties,
      },
      {
        Header: () => {
          return (
            <span>
              Order
              <br />
              Preference
            </span>
          );
        },
        accessor: SiteEnum.OrderPreferenceName,
        ...ReactTableWrapperColumnProperties,
      },
      {
        Header: 'Min. Par',
        accessor: SiteEnum.MinimumParLevel,
        ...ReactTableWrapperColumnProperties,
        show: checkVisibilityForSiteUser(this.props),
        visibility: checkVisibilityForSiteUser(this.props),
        Cell: rowInfo => {
          return (
            <EditableLabel
              label={
                String(rowInfo.original[SiteEnum.MinimumParLevel])
                  ? rowInfo.original[SiteEnum.MinimumParLevel]
                  : ''
              }
              labelClassName={'qtyLabel'}
              refData={rowInfo.original}
              inputType={'text'}
              onChange={this.handleChangeMinPar}
              allowEdit={true}
              className={' ht-26 mt--5'}
              disabled={!rowInfo.original[SiteEnum.CheckBox]}
            />
          );
        },
      },
      {
        Header: 'Max. Par',
        accessor: SiteEnum.MaximumParLevel,
        ...ReactTableWrapperColumnProperties,
        show: checkVisibilityForSiteUser(this.props),
        visibility: checkVisibilityForSiteUser(this.props),
        Cell: rowInfo => {
          return (
            <EditableLabel
              label={
                String(rowInfo.original[SiteEnum.MaximumParLevel])
                  ? rowInfo.original[SiteEnum.MaximumParLevel]
                  : ''
              }
              labelClassName={'qtyLabel'}
              refData={rowInfo.original}
              inputType={'text'}
              onChange={this.handleChangeMaxPar}
              allowEdit={true}
              className={' ht-26 mt--5'}
              disabled={!rowInfo.original[SiteEnum.CheckBox]}
            />
          );
        },
      },
    ],
  };
  handleHeaderLevelCheckBoxWithStorageLocation = checked => {
    const {
      isRightGridFiltered,
      rightSideGridReactTableRef,
      dataSource,
      siteGridInfo,
      isLeftGridFiltered,
      isStorageLocationPage,
      isLeftSideUserGrid,
      leftSideGridReactTableRef,
    } = this.props;
    if (
      (isLeftSideUserGrid &&
        isRightGridFiltered &&
        rightSideGridReactTableRef &&
        rightSideGridReactTableRef.current) ||
      (isLeftGridFiltered &&
        isStorageLocationPage &&
        leftSideGridReactTableRef &&
        leftSideGridReactTableRef.current)
    ) {
      const sortedData = isLeftSideUserGrid
        ? rightSideGridReactTableRef.current.getResolvedState().sortedData
        : leftSideGridReactTableRef.current.getResolvedState().sortedData;
      const sortedSitesData = getFilteredIds(sortedData, SiteEnum.Id);
      let siteGridInfoCopy = [...siteGridInfo];
      let sitesToChange;
      if (checked) {
        sitesToChange = _.union(sortedSitesData, siteGridInfoCopy);
      } else {
        _.remove(siteGridInfoCopy, siteId => {
          return sortedSitesData.includes(siteId);
        });
        sitesToChange = siteGridInfoCopy;
      }
      this.props.input.onChange(sitesToChange);
    } else {
      const sites = checked
        ? _.map(dataSource, site => {
            return site[SiteEnum.Id];
          })
        : [];
      this.props.input.onChange(sites);
    }
    this.props.setIsReadOnlyState(false);
  };

  handleChangeMinPar = (refData, newValue) => {
    this.handleParLevelChange(refData, newValue, SiteEnum.MinimumParLevel);
  };

  handleChangeMaxPar = (refData, newValue) => {
    this.handleParLevelChange(refData, newValue, SiteEnum.MaximumParLevel);
  };

  handleParLevelChange = (refData, newValue, fieldName) => {
    newValue = newValue.match(/\d{0,6}(\.\d{0,3})?/)[0];
    const formValues =
      this.props.input.value && this.props.input.value.length
        ? _.cloneDeep(this.props.input.value)
        : [];
    const index = _.findIndex(formValues, formValue => {
      return formValue[SiteEnum.Id] === refData[SiteEnum.Id];
    });
    if (index > -1) {
      formValues[index][fieldName] = newValue;
    } else {
      const newFiled = Object.assign({}, refData);
      newFiled[fieldName] = newValue;
      formValues.push(newFiled);
    }
    this.props.setIsReadOnlyState(false);
    this.props.input.onChange(formValues);
  };

  prepareTableData = () => {
    const dataSourceCopy =
      this.props.dataSource && this.props.dataSource.length
        ? _.cloneDeep(this.props.dataSource)
        : [];
    //reset grid values
    dataSourceCopy.forEach(site => {
      site[SiteEnum.MinimumParLevel] = '';
      site[SiteEnum.MaximumParLevel] = '';
    });
    const { value } = this.props.input;
    if (value && value.length && dataSourceCopy && dataSourceCopy.length) {
      _.each(value, item => {
        const index = _.findIndex(dataSourceCopy, {
          [SiteEnum.Id]: item[SiteEnum.Id],
        });
        if (index > -1) {
          const dataRow = { ...item };
          dataSourceCopy[index][SiteEnum.MinimumParLevel] =
            dataRow[SiteEnum.MinimumParLevel];
          dataSourceCopy[index][SiteEnum.MaximumParLevel] =
            dataRow[SiteEnum.MaximumParLevel];
          dataSourceCopy[index][SiteEnum.CheckBox] = dataRow[SiteEnum.CheckBox];
        }
      });
    }
    return dataSourceCopy;
  };

  handleHeaderLevelCheckbox = checked => {
    const {
      dataSource,
      input: { value },
      rightSideGridReactTableRef,
    } = this.props;
    let dataSourceCopy =
      dataSource && dataSource.length ? _.cloneDeep(dataSource) : [];
    if (value && value.length && dataSourceCopy && dataSourceCopy.length) {
      _.each(value, formValue => {
        const index = _.findIndex(dataSourceCopy, {
          [SiteEnum.Id]: formValue[SiteEnum.Id],
        });
        if (index > -1) {
          dataSourceCopy[index] = { ...formValue };
        }
      });
    }
    if (rightSideGridReactTableRef && rightSideGridReactTableRef.current) {
      const filteredData = rightSideGridReactTableRef.current.getResolvedState()
        .sortedData;
      _.each(filteredData, filterItem => {
        const index = _.findIndex(dataSourceCopy, {
          [SiteEnum.Id]: filterItem._original[SiteEnum.Id],
        });
        if (index > -1) {
          dataSourceCopy[index] = filterItem._original;
          dataSourceCopy[index][SiteEnum.CheckBox] = checked;
        }
      });
    } else if (dataSourceCopy && dataSourceCopy.length) {
      dataSourceCopy = dataSourceCopy.map(site => {
        site[SiteEnum.CheckBox] = checked;
        return site;
      });
    }

    this.props.setIsReadOnlyState(false);
    this.props.input.onChange(dataSourceCopy);
  };

  componentDidMount() {
    const {
      getAllSites,
      isRightSideUserGrid,
      isRightSideSiteGrid,
      isRightSideItemGrid,
      getUsersBySiteId,
      isLeftMultipleSelect,
      isStorageLocationPage,
      getItemsBySiteId,
      isLeftSideSiteGrid,
    } = this.props;

    !isStorageLocationPage &&
      getAllSites().then(() => {
        const { allSitesData } = this.props;
        if (isLeftSideSiteGrid) {
          this.props.onResetPageOnDataChange({
            ...GridResetInitialValueEnum,
            [GridNames.Site]: false,
            [GridNames.Item]: true,
            [GridNames.User]: true,
          });
        }
        if (allSitesData && allSitesData.length) {
          !isLeftMultipleSelect &&
            isRightSideUserGrid &&
            getUsersBySiteId(allSitesData[0][SiteEnum.Id]);
          !isLeftMultipleSelect &&
            isRightSideItemGrid &&
            getItemsBySiteId(allSitesData[0][SiteEnum.Id]);
          !isLeftMultipleSelect &&
            !isRightSideSiteGrid &&
            this.props.input.onChange([allSitesData[0][SiteEnum.Id]]);
        }
      });
    if (isStorageLocationPage) {
      this.props.onResetPageOnDataChange({
        [GridNames.Site]: true,
        [GridNames.Item]: true,
      });
    }
  }
  componentWillUnmount() {
    this.props.input.onChange([]);
  }

  handleChangeCheckboxWithStorageLocation = (original, checked) => {
    const formValues =
      this.props.input.value && this.props.input.value.length
        ? _.cloneDeep(this.props.input.value)
        : [];
    let index = formValues.indexOf(original[SiteEnum.Id]);
    if (checked) {
      index === -1 && formValues.push(original[SiteEnum.Id]);
    } else {
      if (index !== -1) {
        formValues.splice(index, 1);
      }
    }
    this.props.setIsReadOnlyState(false);
    this.props.input.onChange(formValues);
  };

  handleChangeCheckbox = (original, Checked) => {
    const formValues =
      this.props.input.value && this.props.input.value.length
        ? _.cloneDeep(this.props.input.value)
        : [];
    let index = _.findIndex(formValues, value => {
      return value[SiteEnum.Id] === original[SiteEnum.Id];
    });
    if (index > -1) {
      formValues[index][SiteEnum.CheckBox] = Checked;
    } else {
      formValues.push({
        ...original,
        [SiteEnum.CheckBox]: Checked,
      });
    }
    this.props.setIsReadOnlyState(false);
    this.props.input.onChange(formValues);
  };

  onRowClickProp = (state, rowInfo) => {
    const {
      isRightSideSiteGrid,
      isStorageLocationPage,
      input,
      isLeftSideSiteGrid,
    } = this.props;
    let styleObj = {};
    let style = {
      color: '#df5a17',
      fontWeight: '600',
    };
    if (rowInfo && rowInfo.original && input.value) {
      if (
        isLeftSideSiteGrid &&
        input.value.indexOf(rowInfo.original[SiteEnum.Id]) !== -1
      ) {
        styleObj = style;
      }
    }

    return {
      onClick: () => {
        const { direction, sortOptionsValue, dropDownValue } = this.props;
        const renderedComponent = getComponentOnSelection(
          sortOptionsValue,
          dropDownValue,
          direction
        );
        if (input && input.value && input.value.length) {
          if (
            !isStorageLocationPage &&
            isLeftSideSiteGrid &&
            input.value.indexOf(rowInfo.original[SiteEnum.Id]) === -1
          ) {
            const showUnsavedModal = !this.props.isReadOnly;
            this.setState(
              {
                showUnsavedModal: showUnsavedModal,
                rowInfo,
              },
              () => {
                if (!showUnsavedModal) {
                  this.getAssociatedGridDetails();
                  if (
                    renderedComponent === ComponentMapping.SiteToItemsComponents
                  ) {
                    this.props.onResetPageOnDataChange({
                      ...GridResetInitialValueEnum,
                      [GridNames.Site]: false,
                      [GridNames.Item]: true,
                    });
                  } else if (
                    renderedComponent === ComponentMapping.ItemToSitesComponents
                  ) {
                    this.props.onResetPageOnDataChange({
                      ...GridResetInitialValueEnum,
                      [GridNames.Site]: true,
                      [GridNames.Item]: false,
                    });
                  } else if (
                    renderedComponent === ComponentMapping.SiteToUsersComponents
                  ) {
                    this.props.onResetPageOnDataChange({
                      ...GridResetInitialValueEnum,
                      [GridNames.Site]: false,
                      [GridNames.User]: true,
                    });
                  } else if (
                    renderedComponent === ComponentMapping.UserToSitesComponents
                  ) {
                    this.props.onResetPageOnDataChange({
                      ...GridResetInitialValueEnum,
                      [GridNames.User]: false,
                      [GridNames.Site]: true,
                    });
                  }
                }
              }
            );
          } else if (isRightSideSiteGrid) {
            if (
              renderedComponent === ComponentMapping.SiteToItemsComponents ||
              renderedComponent === ComponentMapping.ItemToSitesComponents ||
              renderedComponent === ComponentMapping.SiteToUsersComponents ||
              renderedComponent === ComponentMapping.UserToSitesComponents
            ) {
              this.props.onResetPageOnDataChange({
                ...GridResetInitialValueEnum,
                [GridNames.Site]: false,
                [GridNames.Item]: false,
                [GridNames.User]: false,
              });
            }
          } else if (isStorageLocationPage) {
            this.props.onResetPageOnDataChange({
              [GridNames.Site]: false,
              [GridNames.Item]: false,
            });
          }
        }
      },
      style: styleObj,
    };
  };
  handleUnsavedModal(result) {
    const { direction, sortOptionsValue, dropDownValue } = this.props;
    const renderedComponent = getComponentOnSelection(
      sortOptionsValue,
      dropDownValue,
      direction
    );
    if (result) {
      this.props.setIsReadOnlyState(true);
      this.getAssociatedGridDetails();
      if (
        renderedComponent === ComponentMapping.SiteToItemsComponents ||
        renderedComponent === ComponentMapping.SiteToUsersComponents
      ) {
        this.props.onResetPageOnDataChange({
          ...GridResetInitialValueEnum,
          [GridNames.Site]: false,
          [GridNames.Item]: true,
          [GridNames.User]: true,
        });
      } else if (
        renderedComponent === ComponentMapping.ItemToSitesComponents ||
        renderedComponent === ComponentMapping.UserToSitesComponents
      ) {
        this.props.onResetPageOnDataChange({
          ...GridResetInitialValueEnum,
          [GridNames.Item]: false,
          [GridNames.Site]: true,
          [GridNames.User]: true,
        });
      }
    } else {
      if (
        renderedComponent === ComponentMapping.SiteToItemsComponents ||
        renderedComponent === ComponentMapping.ItemToSitesComponents ||
        renderedComponent === ComponentMapping.SiteToUsersComponents ||
        renderedComponent === ComponentMapping.UserToSitesComponents
      ) {
        this.props.onResetPageOnDataChange({
          ...GridResetInitialValueEnum,
          [GridNames.Site]: false,
          [GridNames.Item]: false,
          [GridNames.User]: false,
        });
      }
    }

    this.setState({
      showUnsavedModal: false,
      rowInfo: null,
    });
  }

  getAssociatedGridDetails = () => {
    const {
      isLeftSideSiteGrid,
      isLeftMultipleSelect,
      isRightSideItemGrid,
      isRightSideUserGrid,
    } = this.props;
    const { rowInfo } = this.state;
    if (
      rowInfo &&
      rowInfo.original &&
      isLeftSideSiteGrid &&
      !isLeftMultipleSelect
    ) {
      this.props.clearItemGridFilter();
      if (isRightSideItemGrid) {
        this.props.getItemsBySiteId(rowInfo.original[SiteEnum.Id]);
      } else if (isRightSideUserGrid) {
        this.props.getUsersBySiteId(rowInfo.original[SiteEnum.Id]);
      }
      if (
        this.props.input.value.indexOf(rowInfo.original[SiteEnum.Id]) === -1
      ) {
        this.props.input.onChange([rowInfo.original[SiteEnum.Id]]);
      }
    }
  };

  render() {
    const {
      loadingAllSites,
      dataSource,
      loadingStorageLocationById,
      setSiteGridInstance,
      onFilteredChange,
      rightSideGridReactTableRef,
      isLeftSideUserGrid,
      leftSideGridReactTableRef,
      onLeftGridFilteredChange,
      isStorageLocationPage,
      onResetPageOnDataChange,
      resetGridPage,
    } = this.props;
    return (
      <Fragment>
        <Form.Field>
          <ReactTable
            minRows={0}
            reactTableRef={
              isStorageLocationPage
                ? leftSideGridReactTableRef
                : rightSideGridReactTableRef
            }
            loading={loadingAllSites || loadingStorageLocationById}
            data={
              this.props.isRightSideSiteGrid && !this.props.isLeftSideUserGrid
                ? this.prepareTableData()
                : dataSource
                  ? dataSource
                  : []
            }
            resizable={true}
            className={'-striped -highlight grid--fixed-row-height'}
            laodingText={
              loadingAllSites || loadingStorageLocationById ? 'Loading...' : ''
            }
            noDataText={loadingAllSites ? '' : 'No sites found'}
            getTrProps={this.onRowClickProp}
            columns={this.state.columns}
            menu={false}
            saveState={{
              tableName: isStorageLocationPage
                ? TableNamesEnum.ASSIGN_ENTITIES_STORAGE_LOCATION_SITE_GRID_TABLE
                : TableNamesEnum.ASSIGN_ENTITIES_SITE_GRID_TABLE,
            }}
            onRef={setSiteGridInstance}
            resetPageOnDataChange={resetGridPage[GridNames.Site]}
            onResetPageOnDataChange={onResetPageOnDataChange}
            onFilteredChange={
              isLeftSideUserGrid ? onFilteredChange : onLeftGridFilteredChange
            }
          />
        </Form.Field>
        <YesNoDialog
          showDialog={this.state.showUnsavedModal}
          title="Un-saved changes detected"
          question={UNSAVED_MESSAGE}
          yesCallback={() => {
            this.handleUnsavedModal(true);
          }}
          noCallback={() => {
            this.handleUnsavedModal(false);
          }}
        />
      </Fragment>
    );
  }
}

const assignEntitiesFormValueSelector = formValueSelector(
  ASSIGN_ENTITIES_FORM_NAME
);
const storageLocationFormValueSelector = formValueSelector(
  ASSIGN_ENTITIES_STORAGE_LOCATION_FORM_NAME
);

const mapStateToProps = (state, ownProps) => {
  const selector = ownProps.isStorageLocationPage
    ? storageLocationFormValueSelector
    : assignEntitiesFormValueSelector;

  return {
    loadingAllSites: Selectors.getLoadingAllSites(state),
    allSitesData: Selectors.getAllSitesData(state),
    loadingStorageLocationById: Selectors.getLoadingStorageLocationById(state),
    allItemsData: Selectors.getAllItemsData(state),
    sitesByItemId: Selectors.getSitesByItemId(state),
    usersBySiteId: Selectors.getUsersBySiteId(state),

    siteGridInfo: selector(state, AssignEntitiesEnum.SiteGridInfo),
    sortOptionsValue: selector(state, AssignEntitiesEnum.SortOptions),
    dropDownValue: selector(state, AssignEntitiesEnum.To),
  };
};

const mapDispatchToProps = {
  getItemsBySiteId,
  getAllSites,
  getUsersBySiteId,
  clearItemGridFilter,
};

export const SiteGridContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(SiteGrid);



// WEBPACK FOOTER //
// ./src/pages/utilities/assignentities/containers/assignEntities/SiteGridContainer.js